import { Outlet } from 'react-router-dom';
import { NotFoundHero } from 'restaurantAdmin/errors/NotFoundHero';
import { useAuth } from '../context/AuthContext';

export const IsManager = () => {
  const { isManager } = useAuth();

  return isManager ? <Outlet /> : <NotFoundHero />;
};
